import Card from "../Items/card";
import { useSelector, useDispatch } from "react-redux";
import ItemPreview from "../Items/itemPreview";

export default function ItemsSection() {
  let dispatch = useDispatch();

  const loadProducts = useSelector((state) => state.EMenu.loadProducts);
  const previewItem = useSelector((state) => state.EMenu.previewItem);
  const searchResult = useSelector((state) => state.EMenu.searchResult);
  const cardViewType = useSelector((state) => state.EMenu.cardViewType);

  return (
    <>
      <section className="px-6 max-sm:px-3 mt-4">
        {searchResult.length === 0 ? (
          <div className="text-center my-12 mx-24">
            {loadProducts ? (
              <p>Loading Menu...</p>
            ) : (
              <div className="w-[70%] max-sm:w-[100%] m-auto text-center">
                <p className="text-5xl mt-28 mb-5 font-light">
                  No product found.
                </p>
              </div>
            )}
          </div>
        ) : (
          <>
            <p className="text-lg m-1 uppercase tracking-wide font-extrabold text-dark">
              Searched Items
            </p>
            <div className="overflow-scroll h-[60vh]">
              <ul
                className={`${
                  cardViewType === "grid" &&
                  "grid max-sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
                } ${cardViewType === "list" && "flex flex-col"} gap-3 mb-5`}
              >
                {searchResult.map(
                  ({
                    SellPrice1,
                    SellPrice2,
                    SellPrice3,
                    SellPrice4,
                    SellPrice5,
                    SellPrice6,
                    SellUnit,
                    barcode,
                    cooktime,
                    description,
                    id,
                    image,
                    name,
                    productid,
                    subgroupid,
                    storePrice,
                  }) => (
                    <Card
                      key={id}
                      ProductId={productid}
                      image={image}
                      ProductName={name}
                      description={description}
                      Price={storePrice}
                      time={cooktime}
                    />
                  )
                )}
              </ul>
            </div>
          </>
        )}
        {previewItem && <ItemPreview />}
      </section>
    </>
  );
}
